import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default class TopSlider {
  constructor(elem, opts) {
    this.elm = elem
    this.breakpoint = 768
    this.topSliderFlg = false

    this.eventBinds()
  }

  eventBinds() {
    const _this = this
    window.addEventListener('load', ()=> {
      if(_this.isPC()){
        
        _this.topSliderFlg = true
        _this.addTopSliderControl()
      }
    })

    window.addEventListener('resize', ()=> {
      if(_this.isPC()){
        if(!_this.topSliderFlg){
          _this.topSliderFlg = true
          _this.addTopSliderControl()
        }
      }else{
        if(_this.topSliderFlg){
          _this.topSliderFlg = false
          _this.removeTopSliderControl()
        }
      }
    })
  }

  isPC() {
    if (window.innerWidth >= this.breakpoint) {
      return true
    } else {
      return false
    }
  }

  addTopSliderControl(){
    this.topSlider = new Swiper(".swiper", {
      modules: [ Navigation ],
      slidesPerView: 4,
      spaceBetween: 48,
      freeMode: true,
      navigation: {
        nextEl: '.swiper__top__member__btn.is-next',
        prevEl: '.swiper__top__member__btn.is-prev',
      },
    });
    this.topSlider.on('slideChange', function (e) {
      if(e.activeIndex <= 0){
        document.getElementsByClassName('swiper__top__member__btn is-prev')[0].classList.add('is-deactive')
      }else if((e.activeIndex + 3) >= (e.slides.length - 1)){
        document.getElementsByClassName('swiper__top__member__btn is-next')[0].classList.add('is-deactive')
      }else{
        document.getElementsByClassName('swiper__top__member__btn is-prev')[0].classList.remove('is-deactive')
        document.getElementsByClassName('swiper__top__member__btn is-next')[0].classList.remove('is-deactive')
      }
    });
  }

  removeTopSliderControl(){
    this.topSlider.destroy();
    this.topSlider = undefined;
  }
}